"use strict";

var S = Object.create;
var s = Object.defineProperty,
  W = Object.defineProperties,
  w = Object.getOwnPropertyDescriptor,
  E = Object.getOwnPropertyDescriptors,
  H = Object.getOwnPropertyNames,
  i = Object.getOwnPropertySymbols,
  b = Object.getPrototypeOf,
  n = Object.prototype.hasOwnProperty,
  x = Object.prototype.propertyIsEnumerable;
var m = (o, e, r) => e in o ? s(o, e, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: r
  }) : o[e] = r,
  f = (o, e) => {
    for (var r in e || (e = {})) n.call(e, r) && m(o, r, e[r]);
    if (i) for (var r of i(e)) x.call(e, r) && m(o, r, e[r]);
    return o;
  },
  y = (o, e) => W(o, E(e));
var I = (o, e) => {
  var r = {};
  for (var p in o) n.call(o, p) && e.indexOf(p) < 0 && (r[p] = o[p]);
  if (o != null && i) for (var p of i(o)) e.indexOf(p) < 0 && x.call(o, p) && (r[p] = o[p]);
  return r;
};
var g = (o, e) => {
    for (var r in e) s(o, r, {
      get: e[r],
      enumerable: !0
    });
  },
  P = (o, e, r, p) => {
    if (e && typeof e == "object" || typeof e == "function") for (let t of H(e)) !n.call(o, t) && t !== r && s(o, t, {
      get: () => e[t],
      enumerable: !(p = w(e, t)) || p.enumerable
    });
    return o;
  };
var h = (o, e, r) => (r = o != null ? S(b(o)) : {}, P(e || !o || !o.__esModule ? s(r, "default", {
    value: o,
    enumerable: !0
  }) : r, o)),
  k = o => P(s({}, "__esModule", {
    value: !0
  }), o);
var C = {};
g(C, {
  IconWrapper: () => a
});
module.exports = k(C);
var d = h(require("react")),
  l = require("@twilio-paste/box");
const a = d.forwardRef((N, z) => {
  var c = N,
    {
      as: o = "span",
      color: e = "currentColor",
      display: r = "block",
      element: p = "ICON",
      size: t = "sizeIcon30"
    } = c,
    B = I(c, ["as", "color", "display", "element", "size"]);
  return d.createElement(l.Box, y(f({}, (0, l.safelySpreadBoxProps)(B)), {
    as: o,
    element: p,
    lineHeight: "lineHeight0",
    display: r,
    color: e,
    size: t,
    ref: z
  }));
});
a.displayName = "IconWrapper";